(function () {
  'use strict';

  const triggers = document.querySelectorAll('.ahllya-float-trigger');
  const menu = document.getElementById('ahllya-float-menu');
  if (!triggers.length || !menu) return;

  const panel = menu.querySelector('.ahllya-float-menu__panel');

  function setExpanded(isOpen) {
    triggers.forEach((t) => t.setAttribute('aria-expanded', isOpen ? 'true' : 'false'));
  }

  function openMenu() {
    menu.setAttribute('aria-hidden', 'false');
    setExpanded(true);
    panel.focus();
  }

  function closeMenu(returnFocusTo) {
    menu.setAttribute('aria-hidden', 'true');
    setExpanded(false);
    if (returnFocusTo) returnFocusTo.focus();
    resetToRoot();
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const isOpen = menu.getAttribute('aria-hidden') === 'false';
      isOpen ? closeMenu(trigger) : openMenu();
    });
  });

  menu.querySelector('.ahllya-float-menu__overlay').addEventListener('click', () => closeMenu());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') {
      closeMenu();
    }
  });

  menu.querySelectorAll('.ahllya-float-menu__close').forEach((btn) => {
    btn.addEventListener('click', () => closeMenu());
  });

  const levelStack = [];

  function showLevel(targetLevel) {
    menu.querySelectorAll('.ahllya-float-menu__level').forEach((lvl) => {
      lvl.setAttribute('data-active', 'false');
    });
    targetLevel.setAttribute('data-active', 'true');
    targetLevel.focus();
  }

  function resetToRoot() {
    levelStack.length = 0;
    const root = menu.querySelector('.ahllya-float-menu__level[data-level="0"]');
    if (root) showLevel(root);
  }

  menu.querySelectorAll('.ahllya-float-menu__link--parent').forEach((btn) => {
    btn.addEventListener('click', () => {
      const submenuKey = btn.dataset.submenu;
      const currentLevel = btn.closest('.ahllya-float-menu__level');
      const nextLevel = menu.querySelector(
        `.ahllya-float-menu__level[data-submenu="${submenuKey}"]`
      );
      if (!nextLevel) return;
      levelStack.push(currentLevel);
      showLevel(nextLevel);
    });
  });

  menu.querySelectorAll('.ahllya-float-menu__back').forEach((btn) => {
    btn.addEventListener('click', () => {
      const prev = levelStack.pop();
      if (prev) {
        showLevel(prev);
      } else {
        resetToRoot();
      }
    });
  });
})();
